<template>
  <div class="wrap">
    <button class="input-number-decrement" :disabled="value === min" @click="() => this.inputVal = this.inputVal - step">–</button><input class="input-number" :disabled="true" v-model.number="inputVal" type="text" :min="min" :max="max"><button class="input-number-increment" :disabled="value === max" @click="() => this.inputVal = this.inputVal + step">+</button>
  </div>
</template>

<script>
  import chainableVModel from "../mixins/chainableVModel";

  export default {
    mixins: [chainableVModel],
    props: {
      min: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
         default: Infinity
      },
      step: {
        type: Number,
        default: 1
      },
      value: {
        type: Number
      }
    }
  }
</script>

<style scoped lang="sass">
  .wrap
    display: inline-block
  .input-number
    width: 50px
    padding: 0 12px
    vertical-align: top
    text-align: center
    outline: none
    background-color: #fff

  .input-number,
  .input-number-decrement,
  .input-number-increment
    border: 1px solid #ccc
    height: 40px
    user-select: none

  .input-number-decrement,
  .input-number-increment
    display: inline-block
    width: 30px
    background: #f1f1f1
    color: #444
    text-align: center
    font-weight: bold
    cursor: pointer
    outline: none

    &:active
      background: #ddd

  .input-number-decrement
    border-right: none
    border-radius: 4px 0 0 4px

  .input-number-increment
    border-left: none
    border-radius: 0 4px 4px 0
</style>
